<script setup>
import GoChatBot from "@/components/GoChatBot.vue";
</script>

<template>
  <section class="recommend-section">
    <div class="recommend-content">
      <p class="Finally-content">
        無論何時何地，<br />
        我們都是您<span style="color: #3c5bff">值得信賴</span>的<br
          class="mobile-only"
        />
        1688代買夥伴
      </p>

      <img
        class="chat-picture-mo mobile-only"
        src="@/assets/images/mobile/advantage/Group_3919.svg"
        alt=""
      />

      <img
        class="Finally-picture"
        src="@/assets/images/desktop/recommend/Group_3875.svg"
        alt=""
      />

      <GoChatBot class="Finally-button-pointer" />
    </div>
  </section>
</template>

<style scoped>
/* Recommend Section */
.recommend-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.recommend-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Finally-content {
  font-weight: 500;
  font-size: 20px;
  color: #343a40;
  text-align: center;
  margin-top: 76px;
  line-height: 40px;
}

.chat-picture-mo {
  width: 85%;
  display: block;
  margin: 0 auto;
}

.Finally-picture {
  display: none;
}

.Finally-button-pointer {
  padding-top: 40px;
  padding-bottom: 80px;
  cursor: pointer;
  width: 221px;
  margin-top: 0;
}

.mobile-only {
  display: inline;
}

@media (min-width: 1060px) {
  .Finally-content {
    font-size: 32px;
    margin-top: 80px;
    line-height: 60px;
  }

  .Finally-picture {
    display: block;
    width: 100%;
  }

  .chat-picture-mo {
    display: none;
  }

  .Finally-button-pointer {
    margin-top: 60px;
  }

  .mobile-only {
    display: none;
  }
}
</style>
